import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { warehouseArticle } from '@/mocks/articles';

export default function WarehousePage() {
  return <SeoArticlePage article={warehouseArticle} />;
}